import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/vendor";
const options = { role: ROLE.RESTAURANT };

// Add Vendor API
export const addVendor = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

// Vendor List API
export const listVendor = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

// Vendor Update 
export const editVendor = async (values) => {
  return await axiosInstance(options).put(`${path}/update`, values);
};

// Vendor Delete 
export const deleteVendor = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?o_id=${values.o_id}`);
};

// Vendor Details 
export const vendorDetails = async (values) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${values.vendor_id}`,values);
};

export const vendorOptions = async () => {
  return await axiosInstance(options).get(`${path}/options`);
};